import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var GoogleHangouts = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C5.25 0 1.4 3.806 1.4 8.5S5.25 17 10 17v3c3.368-1.672 8.6-5.305 8.6-11.5C18.6 3.806 14.75 0 10 0zM9 9.741a2.552 2.552 0 01-2.32 2.538.211.211 0 01-.228-.211v-.852c0-.106.079-.194.184-.21A1.265 1.265 0 007.683 10H5.732A.732.732 0 015 9.268V6.732C5 6.328 5.328 6 5.732 6h2.536c.404 0 .732.328.732.732v3.009zm6 0a2.552 2.552 0 01-2.32 2.538.211.211 0 01-.228-.211v-.852c0-.106.079-.194.184-.21A1.266 1.266 0 0013.683 10h-1.951A.732.732 0 0111 9.268V6.732c0-.404.328-.732.732-.732h2.536c.404 0 .732.328.732.732v3.009z"
  }));
});
GoogleHangouts.displayName = 'GoogleHangouts';
export var GoogleHangoutsDimensions = {
  height: 20,
  width: 20
};